module.exports = __webpack_public_path__ + "static/formanalytics1-2e9b9d4647a793215850cb2713ab1eb4.png";